import { getAuthMethods } from 'api/v2/users/authentication';
import { useQuery } from 'react-query';
import { UserCacheKeys } from 'types/cacheKeys.types';

const useGetAuthMethods = () =>
  useQuery(UserCacheKeys.AuthenticationMethods, getAuthMethods);

export default useGetAuthMethods;
